// extracted by mini-css-extract-plugin
module.exports = {"NewButton":"EncountersList_NewButton__pRYhg","Table":"EncountersList_Table__i-oHb","TableHeader":"EncountersList_TableHeader__2iIPL"};